const getters = {
  getDadosLayout(state) {
    return state;
  },
  getMenuPorCodigo(state) {
    return (codigo) => state.menuMapeado.filter((menu) => menu.codigo === codigo)[0];
  },
  getMenusPorCodigo(state) {
    return (codigo) => state.menuMapeado.filter((menu) => menu.codigo === codigo);
  },
  getMenuPorUID(state) {
    // eslint-disable-next-line
    return (uid) => state.menuMapeado.filter((menu) => menu.uid == uid)[0];
  },
  getMenusAbertos(state) {
    return (codigo) => state.menusAbertos.filter((cod) => cod === codigo)[0];
  },
  getAcaoCustomizada(state) {
    return (codigo) => state.acoesCustomizadas[codigo];
  },
  getStatusSidebar(state) {
    return state.statusSidebar;
  },
  getStatusSidebarPesquisa(state) {
    return state.statusSidebarPesquisa;
  },
};

export default getters;
